import React from 'react'

import { ProductFeatureCard } from 'components/product-feature-card/ProductFeatureCard'
import { Content } from 'sdk/components/content/Content'

import type { SdkGetStartedStepCmsContent } from 'core/services/cms/interfaces'

import { MobileCardText } from './MobileCardText'

import styles from './style.module.scss'

interface MobileCardsProps {
  heading: React.ReactNode
  steps: SdkGetStartedStepCmsContent[]
}

export const MobileCards: React.FC<MobileCardsProps> = ({ heading, steps }) => {
  return (
    <Content element='section'>
      <div className={styles.mobileCardsContainer}>
        {heading}
        {steps.map((card, index) => (
          <ProductFeatureCard
            key={index}
            icon={card.iconUrl}
            text={<MobileCardText text={card.text} url={card.url} />}
            row
          />
        ))}
      </div>
    </Content>
  )
}
